import { parseAsStringEnum, useQueryState } from "nuqs";

export enum OneRepMaxSource {
  Velocity = "velocity",
  Manual = "manual",
}

function useOneRepMaxSourceQueryState() {
  return useQueryState(
    "oneRepMaxSource",
    parseAsStringEnum<OneRepMaxSource>(Object.values(OneRepMaxSource)).withDefault(OneRepMaxSource.Velocity)
  );
}

export default useOneRepMaxSourceQueryState;
